import { useQuery } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

/**
 * Fetch the current user's saved collections (name, postCount, coverImage)
 */
export const useCollectionsQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["savedCollections", userId],
    queryFn: async () => {
      const res = await api.get("/posts/collections");
      return res.data.collections || [];
    },
    enabled: enabled && !!userId,
    staleTime: 5_000,
    refetchOnMount: "always",
  });
};
